import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface UnclaimedMoneyResponse {
  unclaimedMoney: UnclaimedMoneyInterface[];
  totalRow: number;
}

export interface UnclaimedMoneyInterface {
  id: number;
  senderVAAccountId: number | null;
  senderAccountId: string | null;
  senderRefId: string | null;
  senderType: string | null;
  senderBalanceBefore: string | null;
  senderBalanceAfter: string | null;
  receiverVaAccountId: number | null;
  receiverAccountId: string | null;
  receiverRefId: string | null;
  receiverType: string;
  receiverBalanceBefore: string | null;
  receiverBalanceAfter: string | null;
  currency: string;
  amount: string;
  paymentRef: string;
  paymentReceivedDate: string;
  createdDate: string;
  status: string;
  remarks: string | null;
  isClaimed: boolean | null;
  claimedPayment: any;
}

const getUnclaimedMoney = async ({
  token,
  pagination,
  globalFilter,
  sorting,
  columnFilters,
}: {
  token: string;
  pagination: MRT_PaginationState;
  globalFilter?: string;
  sorting?: MRT_SortingState;
  columnFilters?: MRT_ColumnFiltersState;
}): Promise<UnclaimedMoneyResponse> => {
  try {
    const params: Record<string, any> = {
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
    };

    if (globalFilter) {
      params.globalFilter = globalFilter;
    }

    if (sorting && sorting.length > 0) {
      params.sortBy = JSON.stringify({
        field: sorting[0].id,
        order: sorting[0].desc ? "DESC" : "ASC",
      });
    }

    if (columnFilters && columnFilters.length > 0) {
      params.filter = JSON.stringify(
        columnFilters.map((filter) => ({
          id: filter.id,
          value: filter.value,
        })),
      );
    }

    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/get-unclaimed-money`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getUnclaimedMoney;
